module.exports = __webpack_public_path__ + "static/media/topographicGrid-01.1c5682eb.jpg";